export const ACTION_AFFECTER = 'affecter';
export const ACTION_TRANSMETTRE = 'transmettre';
export const EXPORT_EXCEL_TYPE_TRANSMISSION = 'transmission';
export const EXPORT_FACTOR_TRANSMISSION = 'FactureFactoFrance';
